/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  Container,
  TextField,
  Divider,
  Stack,
  InputLabel,
  Tooltip,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  TextareaAutosize,
  Snackbar,
  Alert,
} from "@common-ui/ui";
// aws-sdk
import { useHistory } from "react-router-dom";
import { ModalContext } from "../../components/BrowserAlert/modalContext";
import { createAsset, getUserOrgs } from "../../services";

import AlertDialog from "./AlertDialog";
import { ScopingHeader } from "../../components";
import { Info } from "@mui/icons-material";

const INFO = {
  assetID: `The unique Asset Identifier as assigned for your Organization.`,
  make: `The Manufacturer, Make, or Brand that made the device. Usually as displayed on the product tag or front panel.`,
  model: `The Model Number, Catalog ID, or Product Code that identifies the product.`,
  description: `The Description, Nomenclature, or Name of the device. Usually as printed on the product tag or front panel.`,
  options: `Any options, add-ons, or upgrades installed or enabled for the product.`,
  oemSerialNumber: `The serial Number or ID assigned by the Manufacturer of the product. Select non-serialized if no serial number is present.
  Select illegible if present but unreadable.`,
  customSerialNumber: `A custom serial number assigned by the Owner or Client. Different from the Asset ID.`,
  // secondarySerialNumber: ``,
  secondaryAssetID: `The Asset Identifier as assigned by the Owner or Client. Different from the Asset ID.`,
  assetName: `A name to help identify the Asset. Defaults to Asset ID, Make, Model, Description. You can create any name you like, for example: High Capacity Pump #7`,
  comment: ``,
};
export const CreateAssetForm = () => {
  let router = useHistory();
  let { handleModal } = React.useContext(ModalContext);
  const [open, setOpen] = React.useState(false);
  const [currentOrgId, setCurrentOrgId] = React.useState(-1);
  const [isMake, setIsMake] = useState("KNOWN");
  const [isModel, setIsModel] = useState("KNOWN");
  const [isSerialNumber, setIsSerialNumber] = useState("SERIALIZED");
  const [assetID, setAssetID] = useState("");

  const [customer, setCustomer] = useState(null);
  const [places, setPlaces] = useState([]);
  const [toast, setToast] = useState([]);

  const [newPlaceParent, setNewPlaceParent] = useState(undefined);
  // console.log("Customer", customer, "Places", places);

  const handleClickOpen = (id = -1) => {
    setAssetID(id);
    setOpen(true);
  };

  useEffect(async () => {
    try {
      const orgs = await getUserOrgs();

      if (orgs && orgs.length) {
        const orgID = window?.localStorage?.getItem(
          "REDUX_CURRENT_ORGANIZATION"
        )
          ? JSON.parse(
              window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION")
            )
          : undefined;
        if (orgID) {
          setCurrentOrgId(orgID?.id);
        } else {
          const findCurrentOrg = Array.from(orgs).find(
            (org) => org.id === String(orgID)
          );
          if (findCurrentOrg) {
            setCurrentOrgId(findCurrentOrg.id);
          } else {
            setCurrentOrgId(orgs[0].id);
          }
        }
      } else {
        // No orgs
        // alert("Please create an organization");
        handleModal("Please create an organization", "Alert");
        router.push("/orgs/tree-view/overview");
      }
    } catch (error) {}
  }, []);

  const handleClose = () => {
    router.push({
      pathname: `/asset-list`,
    });
    setOpen(false);
  };
  // const router = useHistory();
  const formik = useFormik({
    initialValues: {
      assetID: "",
      make: "",
      model: "",
      description: "",
      options: "",
      oemSerialNumber: "",
      customSerialNumber: "",
      secondaryAssetID: "",
      assetName: "",
      comments: "",
    },
    validationSchema: Yup.object({
      assetID: Yup.string().trim().required("Asset ID is required"),
      make: Yup.string().trim().required("Make is required"),
      model: Yup.string().trim().required("Model is required"),
      description: Yup.string().trim().required("Description is required"),
      options: Yup.string().trim(),
      oemSerialNumber: Yup.string()
        .trim()
        .required("OEM Serial Number is required"),
      customSerialNumber: Yup.string().trim(),
      secondaryAssetID: Yup.string().trim(),
      assetName: Yup.string()
        .trim()
        .required("Asset Name / Nick Name is required"),
      comments: Yup.string().trim(),
    }),
    onSubmit: () => {
      if (!customer) {
        return handleModal("Please create an organization", "Alert");
      }
      async function submit() {
        // console.log("formik", formik);
        let {
          assetID,
          make,
          model,
          description,
          options,
          oemSerialNumber,
          customSerialNumber,
          secondaryAssetID,
          assetName,
          comments,
        } = formik.values;
        const attributes = {
          customer: customer
            ? customer.system_id
              ? customer.system_id
              : customer.id
            : null,
          place: newPlaceParent ? newPlaceParent?.system_id : null,
          id: assetID,
          secondary_id: secondaryAssetID,
          product_type: null,
          make: make,
          make_custom: isMake === "CUSTOM" ? true : false,
          model: model,
          model_custom: isModel === "CUSTOM" ? true : false,
          options: options,
          serial_number: oemSerialNumber,
          non_serialized: isSerialNumber === "NON_SERIALIZED" ? true : false,
          custom_serial_number: customSerialNumber,
          name: assetName,
          description: description,
          disposition: null,
          notes: comments,
          attributes: [
            // {
            //   name: "placeID",
            //   value: newPlaceParent ? newPlaceParent?.system_id : null,
            // },
          ],
        };
        try {
          const { payload } = await onSubmit(attributes);
          setToast([
            ...toast,
            {
              message: "Success",
              open: true,
              severity: "success",
            },
          ]);
          handleClickOpen(payload);
        } catch (error) {
          if (error.message === "Request failed with status code 405") {
            setToast([
              ...toast,
              {
                message: `Asset ID ${assetID} already exists.`,
                open: true,
                severity: "error",
              },
            ]);
          } else {
            setToast([
              ...toast,
              {
                message: error.message,
                open: true,
                severity: "error",
              },
            ]);
          }
          formik.setSubmitting(false);
        }
      }
      submit();
    },
  });

  const onSubmit = async (attributes) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const payload = await createAsset(attributes, currentOrgId);
        /* Once the user successfully signs up, update form state to show the confirm sign up form for MFA */
        resolve({ payload: payload?.system_id });
      } catch (error) {
        reject(error);
      }
    });
  };

  useEffect(() => {
    formik.setFieldValue(
      "assetName",
      `${formik.values.make} ${formik.values.model} ${formik.values.description} ${formik.values.assetID}`
    );
  }, [
    formik.values.make,
    formik.values.model,
    formik.values.description,
    formik.values.assetID,
  ]);
  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
          backgroundColor: "#FFFFFF",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
          // bgcolor: "background.paper",
        }}
      >
        <Container maxWidth="md" component="main">
          <form onSubmit={formik.handleSubmit}>
            <Box
              sx={{
                my: 3,
                // maxWidth: { md: 640 }
              }}
            >
              <div>
                {/* Scoping Header */}
                <ScopingHeader
                  customer={customer}
                  setCustomer={setCustomer}
                  places={places}
                  setPlaces={setPlaces}
                  name="Owner or Client"
                  required={true}
                  setNewPlaceParent={setNewPlaceParent}
                />
              </div>
            </Box>
            <Stack
              direction="column"
              sx={
                {
                  // maxWidth: { md: 320 }
                }
              }
            >
              <div>
                {/* <Business position="end" /> */}
                <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ m: 0, ml: 2.5 }} fontWeight="700">
                    Asset ID
                  </Typography>
                  <span>
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fillRule="evenodd">
                        <polygon
                          id="Shape"
                          fill="#EE2E24"
                          fillRule="nonzero"
                          points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                        ></polygon>
                      </g>
                    </svg>
                  </span>
                </InputLabel>
                <div style={{ display: "flex" }}>
                  <span>
                    <Tooltip placement="left" title={INFO.assetID}>
                      <Info sx={{ fontSize: 14, pr: 0.5 }} color="info" />
                    </Tooltip>
                  </span>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.assetID && formik.errors.assetID
                    )}
                    fullWidth
                    helperText={formik.touched.assetID && formik.errors.assetID}
                    placeholder="Type"
                    margin="normal"
                    sx={{ mt: 0 }}
                    name="assetID"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.assetID}
                  />
                </div>
              </div>
              <div>
                {/* <Business position="end" /> */}
                <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ m: 0, ml: 2.5 }} fontWeight="700">
                    Make
                  </Typography>
                  <span>
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fillRule="evenodd">
                        <polygon
                          id="Shape"
                          fill="#EE2E24"
                          fillRule="nonzero"
                          points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                        ></polygon>
                      </g>
                    </svg>
                  </span>
                  <span>
                    {" "}
                    <FormControl size="small">
                      {/* <FormLabel id="select-customers-type">Select</FormLabel> */}
                      <RadioGroup
                        row
                        aria-labelledby="select-make-type"
                        value={isMake}
                        size="small"
                        onChange={(event, value) => {
                          if (value === "UNKNOWN") {
                            formik.setFieldValue("make", "Unknown");
                          } else {
                            formik.setFieldValue("make", "");
                          }
                          setIsMake(value);
                          // console.log("Value", value);
                        }}
                        name="make-type"
                      >
                        <FormControlLabel
                          value="KNOWN"
                          control={<Radio size="small" />}
                          label="Known"
                          size="small"
                        />
                        <FormControlLabel
                          value="UNKNOWN"
                          control={<Radio size="small" />}
                          label="Unknown"
                          size="small"
                        />
                        <FormControlLabel
                          value="CUSTOM"
                          control={<Radio size="small" />}
                          label="Custom"
                          size="small"
                        />
                      </RadioGroup>
                    </FormControl>
                  </span>
                </InputLabel>
                <div style={{ display: "flex" }}>
                  <span>
                    <Tooltip placement="left" title={INFO.make}>
                      <Info sx={{ fontSize: 14, pr: 0.5 }} color="info" />
                    </Tooltip>
                  </span>
                  <TextField
                    autoComplete="off"
                    disabled={isMake === "UNKNOWN" ? true : false}
                    size="small"
                    error={Boolean(formik.touched.make && formik.errors.make)}
                    fullWidth
                    helperText={formik.touched.make && formik.errors.make}
                    placeholder="Type"
                    margin="normal"
                    sx={{ mt: 0 }}
                    name="make"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.make}
                  />
                </div>
              </div>
              <div>
                {/* <Business position="end" /> */}
                <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ m: 0, ml: 2.5 }} fontWeight="700">
                    Model
                  </Typography>
                  <span>
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fillRule="evenodd">
                        <polygon
                          id="Shape"
                          fill="#EE2E24"
                          fillRule="nonzero"
                          points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                        ></polygon>
                      </g>
                    </svg>
                  </span>
                  <span>
                    {" "}
                    <FormControl size="small">
                      {/* <FormLabel id="select-customers-type">Select</FormLabel> */}
                      <RadioGroup
                        row
                        aria-labelledby="select-model-type"
                        value={isModel}
                        size="small"
                        onChange={(event, value) => {
                          if (value === "UNKNOWN") {
                            formik.setFieldValue("model", "Unknown");
                          } else {
                            formik.setFieldValue("model", "");
                          }
                          setIsModel(value);
                          // console.log("Value", value);
                        }}
                        name="model-type"
                      >
                        <FormControlLabel
                          value="KNOWN"
                          control={<Radio size="small" />}
                          label="Known"
                          size="small"
                        />
                        <FormControlLabel
                          value="UNKNOWN"
                          control={<Radio size="small" />}
                          label="Unknown"
                          size="small"
                        />
                        <FormControlLabel
                          value="CUSTOM"
                          control={<Radio size="small" />}
                          label="Custom"
                          size="small"
                        />
                      </RadioGroup>
                    </FormControl>
                  </span>
                </InputLabel>
                <div style={{ display: "flex" }}>
                  <span>
                    <Tooltip placement="left" title={INFO.model}>
                      <Info sx={{ fontSize: 14, pr: 0.5 }} color="info" />
                    </Tooltip>
                  </span>
                  <TextField
                    autoComplete="off"
                    disabled={isModel === "UNKNOWN" ? true : false}
                    size="small"
                    error={Boolean(formik.touched.model && formik.errors.model)}
                    fullWidth
                    helperText={formik.touched.model && formik.errors.model}
                    placeholder="Type"
                    margin="normal"
                    sx={{ mt: 0 }}
                    name="model"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.model}
                  />
                </div>
              </div>
              <div>
                {/* <Business position="end" /> */}
                <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ m: 0, ml: 2.5 }} fontWeight="700">
                    Description
                  </Typography>
                  <span>
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fillRule="evenodd">
                        <polygon
                          id="Shape"
                          fill="#EE2E24"
                          fillRule="nonzero"
                          points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                        ></polygon>
                      </g>
                    </svg>
                  </span>
                </InputLabel>
                <div style={{ display: "flex" }}>
                  {" "}
                  <span>
                    <Tooltip placement="left" title={INFO.description}>
                      <Info sx={{ fontSize: 14, pr: 0.5 }} color="info" />
                    </Tooltip>
                  </span>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.description && formik.errors.description
                    )}
                    fullWidth
                    helperText={
                      formik.touched.description && formik.errors.description
                    }
                    placeholder="Type"
                    // label="Company or Organization Name"
                    margin="normal"
                    sx={{ mt: 0 }}
                    name="description"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.description}
                  />
                </div>
              </div>
              <div>
                {/* <Business position="end" /> */}
                <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ m: 0, ml: 2.5 }} fontWeight="700">
                    Options
                  </Typography>
                </InputLabel>
                <div style={{ display: "flex" }}>
                  <span>
                    <Tooltip placement="left" title={INFO.options}>
                      <Info sx={{ fontSize: 14, pr: 0.5 }} color="info" />
                    </Tooltip>
                  </span>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.options && formik.errors.options
                    )}
                    fullWidth
                    helperText={formik.touched.options && formik.errors.options}
                    placeholder="Type"
                    // label="Company or Organization Name"
                    margin="normal"
                    sx={{ mt: 0 }}
                    name="options"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.options}
                  />
                </div>
              </div>
              <div>
                {/* <Business position="end" /> */}
                <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ m: 0, ml: 2.5 }} fontWeight="700">
                    OEM Serial Number
                  </Typography>
                  <span>
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fillRule="evenodd">
                        <polygon
                          id="Shape"
                          fill="#EE2E24"
                          fillRule="nonzero"
                          points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                        ></polygon>
                      </g>
                    </svg>
                  </span>
                  <span>
                    {" "}
                    <FormControl size="small">
                      {/* <FormLabel id="select-customers-type">Select</FormLabel> */}
                      <RadioGroup
                        row
                        aria-labelledby="select-oemSerialNumber-type"
                        value={isSerialNumber}
                        size="small"
                        onChange={(event, value) => {
                          if (value === "NON_SERIALIZED") {
                            formik.setFieldValue(
                              "oemSerialNumber",
                              "Non-Serialized"
                            );
                          } else if (value === "ILLEGIBLE") {
                            formik.setFieldValue(
                              "oemSerialNumber",
                              "Illegible"
                            );
                          } else {
                            formik.setFieldValue("oemSerialNumber", "");
                          }
                          setIsSerialNumber(value);
                          // console.log("Value", value);
                        }}
                        name="oemSerialNumber-type"
                      >
                        <FormControlLabel
                          value="SERIALIZED"
                          control={<Radio size="small" />}
                          label="Serialized"
                          size="small"
                        />
                        <FormControlLabel
                          value="NON_SERIALIZED"
                          control={<Radio size="small" />}
                          label="Non-Serialized"
                          size="small"
                        />
                        <FormControlLabel
                          value="ILLEGIBLE"
                          control={<Radio size="small" />}
                          label="Illegible"
                          size="small"
                        />
                      </RadioGroup>
                    </FormControl>
                  </span>
                </InputLabel>

                <div style={{ display: "flex" }}>
                  {" "}
                  <span>
                    <Tooltip placement="left" title={INFO.oemSerialNumber}>
                      <Info sx={{ fontSize: 14, pr: 0.5 }} color="info" />
                    </Tooltip>
                  </span>
                  <TextField
                    autoComplete="off"
                    disabled={isSerialNumber !== "SERIALIZED" ? true : false}
                    size="small"
                    error={Boolean(
                      formik.touched.oemSerialNumber &&
                        formik.errors.oemSerialNumber
                    )}
                    fullWidth
                    helperText={
                      formik.touched.oemSerialNumber &&
                      formik.errors.oemSerialNumber
                    }
                    placeholder="Type"
                    margin="normal"
                    sx={{ mt: 0 }}
                    name="oemSerialNumber"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.oemSerialNumber}
                  />
                </div>
              </div>
              <div>
                {/* <Business position="end" /> */}
                <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ m: 0, ml: 2.5 }} fontWeight="700">
                    Custom Serial Number
                  </Typography>
                </InputLabel>
                <div style={{ display: "flex" }}>
                  {" "}
                  <span>
                    <Tooltip placement="left" title={INFO.customSerialNumber}>
                      <Info sx={{ fontSize: 14, pr: 0.5 }} color="info" />
                    </Tooltip>
                  </span>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.customSerialNumber &&
                        formik.errors.customSerialNumber
                    )}
                    fullWidth
                    helperText={
                      formik.touched.customSerialNumber &&
                      formik.errors.customSerialNumber
                    }
                    placeholder="Type"
                    // label="Company or Organization Name"
                    margin="normal"
                    sx={{ mt: 0 }}
                    name="customSerialNumber"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.customSerialNumber}
                  />
                </div>
              </div>

              <div>
                {/* <Business position="end" /> */}
                <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ m: 0, ml: 2.5 }} fontWeight="700">
                    Secondary Asset ID
                  </Typography>
                </InputLabel>
                <div style={{ display: "flex" }}>
                  <span>
                    <Tooltip placement="left" title={INFO.secondaryAssetID}>
                      <Info sx={{ fontSize: 14, pr: 0.5 }} color="info" />
                    </Tooltip>
                  </span>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.secondaryAssetID &&
                        formik.errors.secondaryAssetID
                    )}
                    fullWidth
                    helperText={
                      formik.touched.secondaryAssetID &&
                      formik.errors.secondaryAssetID
                    }
                    placeholder="Type"
                    // label="Company or Organization Name"
                    margin="normal"
                    sx={{ mt: 0 }}
                    name="secondaryAssetID"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.secondaryAssetID}
                  />
                </div>
              </div>

              <div>
                {/* <Business position="end" /> */}
                <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ m: 0, ml: 2.5 }} fontWeight="700">
                    Asset Name / Nick Name
                  </Typography>
                  <span>
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fillRule="evenodd">
                        <polygon
                          id="Shape"
                          fill="#EE2E24"
                          fillRule="nonzero"
                          points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                        ></polygon>
                      </g>
                    </svg>
                  </span>
                </InputLabel>
                <div style={{ display: "flex" }}>
                  <span>
                    <Tooltip placement="left" title={INFO.assetName}>
                      <Info sx={{ fontSize: 14, pr: 0.5 }} color="info" />
                    </Tooltip>
                  </span>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.assetName && formik.errors.assetName
                    )}
                    fullWidth
                    helperText={
                      formik.touched.assetName && formik.errors.assetName
                    }
                    placeholder="Type"
                    margin="normal"
                    sx={{ mt: 0 }}
                    name="assetName"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.assetName}
                  />
                </div>
              </div>

              <div>
                {/* <Business position="end" /> */}
                <InputLabel sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ m: 0, ml: 2.5 }} fontWeight="700">
                    Comments
                  </Typography>
                </InputLabel>
                <div style={{ display: "flex" }}>
                  <span
                    style={{ visibility: "hidden", opacity: 0, cursor: "none" }}
                  >
                    <Tooltip placement="left" title={INFO.assetID}>
                      <Info sx={{ fontSize: 14, pr: 0.5 }} color="info" />
                    </Tooltip>
                  </span>
                  <TextField
                    autoComplete="off"
                    size="small"
                    error={Boolean(
                      formik.touched.comments && formik.errors.comments
                    )}
                    fullWidth
                    helperText={
                      formik.touched.comments && formik.errors.comments
                    }
                    placeholder="Type"
                    // label="Company or Organization Name"
                    margin="normal"
                    sx={{ mt: 0 }}
                    name="comments"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.comments}
                    InputProps={{
                      inputComponent: TextareaAutosize,
                      inputProps: { minRows: 4 },
                    }}
                    variant="outlined"
                  />
                </div>
              </div>
            </Stack>

            <Stack
              sx={
                {
                  // maxWidth: { md: 640 }
                }
              }
            >
              {/* <Divider sx={{ mb: 2, mt: 2 }} /> */}

              <Divider sx={{ py: 1 }} />
              <Stack
                direction={{ xs: "column", md: "row" }}
                justifyContent="flex-end"
                spacing={{ xs: 1, md: 2 }}
                sx={{ py: 2 }}
              >
                <div>
                  <Button
                    color="primary"
                    // disabled={formik.isSubmitting}
                    fullWidth
                    size="large"
                    onClick={() => router.goBack()}
                    // type="submit"
                    variant="text"
                  >
                    Cancel
                  </Button>
                </div>
                <div>
                  <Button
                    color="secondary"
                    disabled={!(formik.isValid && formik.dirty && customer)}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Save
                  </Button>
                </div>
              </Stack>
            </Stack>
          </form>
          {toast.map((item, id) => {
            return (
              <Snackbar
                key={id}
                open={item.open}
                autoHideDuration={6000}
                onClose={() => {
                  setToast(toast.filter((v, i) => i !== id));
                }}
              >
                <Alert
                  onClose={() => {
                    setToast(toast.filter((v, i) => i !== id));
                  }}
                  severity={item.severity}
                  sx={{ width: "100%" }}
                  variant="filled"
                >
                  {item.message}
                </Alert>
              </Snackbar>
            );
          })}
        </Container>
      </Box>
      <AlertDialog id={assetID} handleClose={handleClose} open={open} />
    </>
  );
};
